<script>
export default {
  name: 'BookmakerStackerTile',
  props: {
    brand: {
      type: String,
      required: true,
    },
    pos: {
      type: String,
      required: true,
    },
    bookmaker: {
      type: String,
      required: true,
    },
    bookmakerInfo: {
      type: String,
      required: true,
    },
    bookmakerLink: {
      type: String,
      required: true,
    },
    primaryColor: {
      type: String,
      required: true,
    },
  },
  computed: {
    imageUrl() {
      const { bookmaker } = this;
      return `https://puntcdn.com/stackers/${bookmaker}.svg`;
    },
  },
};
</script>

<template>
  <div class="bookie-stacker-tile">
    <div v-if="pos === '1'" class="bookie-tile__recommended">Recommended Bookmaker</div>
    <a :class="`bookie-tile__container pos-${pos}`" :href="bookmakerLink" target="_blank">
      <div :class="`bookie-tile__number ${brand}`">{{ pos }}</div>
      <div class="bookie-tile__bookie-container">
        <div
          v-lazy:background-image="imageUrl"
          :style="`background-color:${primaryColor}`"
          class="bookie-tile__bookie-icon"
        >
          <div :style="`color:${primaryColor}`" class="bookie-tile__claim-button">Claim Now</div>
        </div>
        <div class="bookie-tile__container-left">
          <div class="bookie-tile__bookie-info">{{ bookmakerInfo }}</div>
          <div v-if="pos === '1'" class="bookie-tile__recommended-claim">Claim Now</div>
        </div>
      </div>
    </a>
    <div class="divider"></div>
  </div>
</template>
